import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { WavePodiumItem } from "./WavePodiumItem";
interface WaveWinnersPodiumContentProps {
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly firstPlaceWinner?: ApiWaveDecisionWinner | undefined;
  readonly secondPlaceWinner?: ApiWaveDecisionWinner | undefined;
  readonly thirdPlaceWinner?: ApiWaveDecisionWinner | undefined;
  readonly showVoteDetails?: boolean | undefined;
}
export const WaveWinnersPodiumContent: React.FC<WaveWinnersPodiumContentProps> = t0 => {
  const $ = _c(16);
  const {
    onDropClick,
    firstPlaceWinner,
    secondPlaceWinner,
    thirdPlaceWinner,
    showVoteDetails: t1
  } = t0;
  const showVoteDetails = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== onDropClick || $[1] !== secondPlaceWinner || $[2] !== showVoteDetails) {
    t2 = <div><WavePodiumItem winner={secondPlaceWinner} onDropClick={onDropClick} position="second" customAnimationIndex={1} showVoteDetails={showVoteDetails} /></div>;
    $[0] = onDropClick;
    $[1] = secondPlaceWinner;
    $[2] = showVoteDetails;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== firstPlaceWinner || $[5] !== onDropClick || $[6] !== showVoteDetails) {
    t3 = <div><WavePodiumItem winner={firstPlaceWinner} onDropClick={onDropClick} position="first" customAnimationIndex={0} showVoteDetails={showVoteDetails} /></div>;
    $[4] = firstPlaceWinner;
    $[5] = onDropClick;
    $[6] = showVoteDetails;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== onDropClick || $[9] !== showVoteDetails || $[10] !== thirdPlaceWinner) {
    t4 = <div><WavePodiumItem winner={thirdPlaceWinner} onDropClick={onDropClick} position="third" customAnimationIndex={2} showVoteDetails={showVoteDetails} /></div>;
    $[8] = onDropClick;
    $[9] = showVoteDetails;
    $[10] = thirdPlaceWinner;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className="tw-relative tw-mx-auto tw-rounded-xl tw-overflow-hidden tw-pt-6 lg:tw-px-4 tw-bg-iron-950/60"><div className="md:tw-max-w-3xl tw-mx-auto"><div className="tw-grid tw-grid-cols-3 tw-gap-x-2 lg:tw-gap-x-4 tw-items-end">{t2}{t3}{t4}</div></div></div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};